module.exports = __webpack_public_path__ + "img/shogi_2021_pack_3_0009.a1930ea7.png";